var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callGraphQL } from '../../common/common';
import { getBetaKey as getBetaKeyQuery, betaKeyByOwnerByEmail as betaKeyByOwnerByEmailQuery, listBetaKeys as listBetaKeysQuery } from '../../../graphql/queries';
/**
 * Get a beta key
 *
 * ONLY users in the `Employee` group can invoke this function.
 * @param id Beta key id
 */
export function getBetaKey(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return callGraphQL(getBetaKeyQuery, { id: id }).then((res) => {
            var _a;
            return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.getBetaKey;
        });
    });
}
/**
 * List the beta keys created by a user
 *
 * ONLY users in the `Employee` group can invoke this function.
 * @param id Id of the user
 * @param optParams
 */
export function listUsersBetaKeys(id, optParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = Object.assign({ owner: id }, optParams);
        return callGraphQL(betaKeyByOwnerByEmailQuery, params).then((res) => {
            var _a;
            const { items, nextToken } = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.betaKeyByOwnerByEmail;
            return {
                items,
                nextToken
            };
        });
    });
}
/**
 * List beta keys
 *
 * ONLY users in the `Employee` group can invoke this function.
 * @param optParams
 */
export function listBetaKeys(optParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = Object.assign({}, optParams);
        return callGraphQL(listBetaKeysQuery, params).then((res) => {
            var _a;
            const { items, nextToken } = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.listBetaKeys;
            return {
                items,
                nextToken
            };
        });
    });
}
